const TopBanner: React.FC = () => {
  return (
    <div className="bg-primary text-sm md:text-base myContainer h-32 md:h-20 flex justify-center text-center items-center text-white">
      <p>
        Honeypotz Inc. is thrilled to announce a strategic agreement with
        FasterCapital, a Dubai-based investment firm, to raise *$3 million* in
        funding. This partnership marks a significant milestone in our mission
        to advance AI security solutions and drive innovation in confidential
        computing.
      </p>
    </div>
  );
};

export default TopBanner;
